export default __webpack_public_path__ + "static/media/vegan-food-and-beverage-products-square.1685e8e5.png";